/*
	index.js -- Initializes the SummIT application and injects it into the browser DOM.
*/

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { App } from 'App';
import { ErrorBoundary } from 'Components/ErrorBoundary/ErrorBoundary';
import { ScrollToTopWhenPathChanges } from 'Components/ScrollToTopWhenPathChanges';

import * as serviceWorker from './serviceWorker';

import './index.css';

createRoot(document.getElementById('root')!).render(
    <BrowserRouter>
        <ErrorBoundary>
            {/* Using a `portalId` for `DatePicker` ensures the "popper" (the dialog where the user selects a date) renders above other elements even when the date picker is in a modal. Without `portalId`, date pickers will be clipped by the boundaries of modals, which are set to have scrollable overflowing content. This approach is specific to the react-datepicker library. */}
            <div id="react-datepicker-portal"></div>
            <ScrollToTopWhenPathChanges />
            <App />
        </ErrorBoundary>
    </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
